import React, { Component } from 'react';
import './css/adminwelcome.css';

class Welcome extends Component {
	constructor(props){
		super(props);
		//console.log("AdminWelcome()");
		this.state = {scheduledState: ""};
	}
	componentDidMount() {
	}

	componentWillUnmount() {
	}

	scheduledOutage(){
		//console.log("Welcome.scheduledOutage()");
		var s = window.l10n[window.locale]["welcome.message"].trim().split("#");
		var title = s[0] || "";
		var message = s[1] || "";
		
		document.getElementById("id-adminwelcome-scheduled-title").innerHTML = title;
		document.getElementById("id-adminwelcome-scheduled-message").innerHTML = message;
		this.setState({scheduledState: "scheduled"});
	}
	
	render() {
		return (
			<div id="adminwelcomepage" className={"welcome-container " + this.state.scheduledState}>
				<div className="welcome-r1">&nbsp;					
				</div>
				<div className="welcome-r2">
					{ window.l10n[window.locale]["landing.documentcentre"] }
				</div>
				<div className="welcome-r3"/>
				<div id="id-adminwelcome-scheduled" className="welcome-scheduled">
					<div id="id-adminwelcome-scheduled-title"/>
					<div id="id-adminwelcome-scheduled-message"/>					
				</div>
			</div>
		);
	}
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/adminwelcome.js